// @ts-nocheck
import axios from 'axiosInstance';

export const getGlobalSettings = () => {
  return axios.get('/global/settings');
};
